import { render } from "./ThankYouPage.vue?vue&type=template&id=22f18dbf"
import script from "./ThankYouPage.vue?vue&type=script&lang=ts"
export * from "./ThankYouPage.vue?vue&type=script&lang=ts"
script.render = render

export default script